export default __webpack_public_path__ + "static/media/insta.5be46ff6.jpg";